export const stringIncludes = (str?: string, search?: string): boolean => {
  if (!str || !search) {
    return false;
  }
  return str.toLowerCase().includes(search.toLowerCase());
};
